<template>
  <div
    class="login-container flex flex-row justify-end align-center"
  >
    <div class="login-body-container flex flex-col align-center">
      <div class="login-form-head flex flex-col">
        <!--    logo 与标题 start    -->
        <div class="head-title flex flex-row align-center justify-center">
          <img class="logo" src="@/assets/login/logo.png" alt="logo">
          <span class="title">
            导萃药房管理系统
          </span>
        </div>
        <!--    logo 与标题 end    -->
        <img class="divider-line w-full" src="@/assets/login/Rectangle.png" alt="分割线">
      </div>
      <div class="login-form w-full">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          auto-complete="on"
          label-position="left"
        >
          <!--     账号 start     -->
          <el-form-item prop="username">
            <div class="login-input flex flex-row align-center">
              <div class="icon-con h-full flex flex-row align-center">
                <svg-icon class-name="icon" icon-class="user" />
              </div>
              <el-input
                v-model="formData.userCode"
                class="h-full background-white"
                type="text"
                @keyup.enter.native="login"
              />
            </div>
          </el-form-item>
          <!--     账号 end     -->
          <!--     密码 start     -->
          <el-form-item prop="password">
            <div class="login-input flex flex-row align-center">
              <div class="icon-con h-full flex flex-row align-center">
                <svg-icon icon-class="lock" />
              </div>
              <el-input
                v-model="formData.passWord"
                :type="passwordType"
                class="h-full background-white"
                @keyup.enter.native="login"
              >
                <template #suffix>
                  <span class="icon-con eye-icon h-full flex flex-row align-center" @click="showPwd">
                    <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                  </span>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <!--     密码 end     -->
          <el-button
            :loading="loading"
            type="primary"
            class="login-btn"
            @click.native.prevent="login"
          >登录
          </el-button>
        </el-form>
      </div>

      <div class="form-divider-line w-full" />
      <div class="footer w-full flex flex-row justify-center align-center" @click="goto">
        鲁ICP备2025152110号-1
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from '@/api/user/authApi'
import md5 from 'js-md5'
import TIM from 'tim-js-sdk' // 引入腾讯云IM SDK
export default {
  name: 'Login',
  data() {
    return {
      timer: 0,
      formData: {
        userCode: '',
        passWord: '',
        type: '1'
      },
      // 验证规则
      rules: {
        userCode: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在6到15个字符', trigger: 'blur' }
        ],
        passWord: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在6到30个字符', trigger: 'blur' }
        ]
      },
      // 登录标识
      loading: false,
      // 密码显示方式
      passwordType: 'password',
      title: this.$store.getters['setting/getTitle']
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 备案跳转
     */
    goto() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index")
    },
    // 切换密码显示
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    /**
     * 登录
     */
    // login() {
    //   this.loading = true
    //   // 测试代码，使用默认账号登录
    //   if (this.formData.userCode === "admin" && this.formData.passWord === "DaoCui@2000") {
    //     // 写入用户信息
    //     this.$store.dispatch('user/login', {
    //       'token': 'testToken',
    //       'userCode': this.formData.userCode,
    //       'userName': this.formData.userCode,
    //       'userRole': 'ADMIN',
    //       'roleCode': 'manager',
    //       'roleName': '管理组',
    //       'securityLevel': '',
    //       'fieldSecurityLevel': ''
    //     })
    //     this.$router.push({ path: this.redirect || '/base/home' })
    //     this.loading = false
    //   } else {
    //     this.$message({ type: 'error', message: '用户名、密码错误' })
    //     this.loading = false
    //   }
    // }
    // 登录
    login() {
      // 如果为13位，则为门店用户
      if (this.formData.userCode.length === 13) {
        this.formData.type = '2'
      }
      const password = md5(this.formData.passWord)
      // 登录
      const pd = {
        code: this.formData.userCode,
        password: password,
        type: this.formData.type
      }
      this.loading = true
      postData('base/user/user/pharmacy/do/pharmacylogin', pd)
        .then(response => {
        // 写入用户信息
          this.$store.dispatch('user/login', {
            'token': response.data.token,
            'userCode': response.data.code,
            'userName': response.data.name,
            'userRole': response.data.userRole,
            'storeId': response.data.storeId,
            'storeCode': response.data.storeCode,
            'storeName': response.data.storeName,
            'securityLevel': '',
            'fieldSecurityLevel': '',
            'doctorType': response.data.doctorType
          })
          localStorage.setItem('user', JSON.stringify(this.$store.state.user))
          // 新增：生成UserSig并登录IM
          this.loginIM(response.data)
          this.$router.push({ path: this.redirect || '/base/home' })
          this.loading = false
        }).catch(response => {
          this.loading = false
        })
    },
    /**
     * 登录腾讯云IM
     */
    async loginIM(userData) {
      try {
        // console.log(LibGenerateTestUserSig);

        // // 1. 使用官方库生成UserSig
        // const generator = new LibGenerateTestUserSig(
        //   1400539979, // SDKAppID
        //   '5306a37ec11b3a517883e975c9201cfb8e303a17f10a695ae2ed3ae019384ece' // SecretKey
        // )

        // const userSig = generator.genTestUserSig(userData.code) // 生成UserSig

        // 2. 创建IM实例
        const tim = TIM.create({
          SDKAppID: 1400539979 // 应用ID
        })

        // 3. 设置日志级别
        tim.setLogLevel(1)

        // 4. 登录IM
        await tim.login({
          userID: userData.code, // 使用用户ID作为IM账号
          userSig: 'eJwtzEELgjAYxvHvsnPInL2uCR2sQ0iKlJ28idvsNWZLxYrou2fq8fk98P*QS5w5g2pJQJhDyWraKFXTo8aJC2mwWY5O3gprUZLAXVMKnhBczI96WWzV6ADAKKWz9mj*xoExVwjwlwpWY-cqtR7u*zg37u5wrMvUj3gblV3-gOScc-5O0jp7Vt7mFG7J9wc49DGJ' // 使用官方库生成的签名
        })

        console.log('IM登录成功')

        // 5. 将tim实例挂载到全局
        this.$store.commit('SET_TIM_INSTANCE', tim)
      } catch (error) {
        console.error('IM登录失败', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border-color: transparent;
  height: 100%;
  background-color: #ffffff !important;

  &:hover {
    border-color: transparent;
  }
}
.login-container {
  background-image: url("../../../../assets/login/BG.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left center;
  height: 100vh;
  background-color: #F9FAFC;

  .login-body-container {
    margin-right: 200px;
    background-color: #FFFFFF;
    padding: 27px 0 0 0;
    width: 504px;
    height: 490px;

    .login-form-head {
      margin-bottom: 40px;

      .head-title {
        margin-bottom: 23px;

        .logo {
          width: 36px;
          height: 36px;
          margin-right: 16px;
        }

        .title {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .divider-line {
        height: 10px;
      }
    }

    // 登录表单
    .login-form {
      padding: 0 40px 0 40px;
      margin-bottom: 55px;

      .login-input {
        width: 424px;
        height: 52px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #EFF3F5;
        margin-bottom: 35px;

        .icon-con {
          padding: 0 20px;

          .icon {
            font-size: 16px;
          }

          .eye-icon {
            cursor: pointer;
          }
        }

      }

      .login-btn {
        width: 424px;
        height: 50px;
        background: linear-gradient(90deg, #026CFF 0%, #00A3FE 100%);
        border-radius: 8px 8px 8px 8px;
      }

    }

    .form-divider-line {
      height: 4px;
      background: linear-gradient(180deg, rgba(142, 145, 147, 0.1) 0%, rgba(241, 245, 249, 0) 100%);
      opacity: 0.5;
      margin-bottom: 17px;
    }

    .footer {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: 400;
      font-size: 12px;
      color: #9DA7B4;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
